module.exports = __webpack_public_path__ + "img/ed19541.webp";